import React from "react";
import Loader from "../sublayouts/components/loader";
import {type LoaderContextValue, type LoaderManagerState} from "../types/managers";

const {Provider, Consumer} = React.createContext<LoaderContextValue>({
  setLoading: undefined,
});


export const LoaderProvider = Provider;
export const LoaderConsumer = Consumer;

export class LoaderManager extends React.Component<React.PropsWithChildren<{}>, LoaderManagerState> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props);
    this.state = {
      loaders: {},
    };
  }

  setLoading = (key: string, status: boolean): void => {
    const loaders = {
      ...this.state.loaders,
    };
    loaders[key] = status;
    return this.setState({
      loaders,
    });
  };

  render() {
    const isLoading = Object.keys(this.state.loaders).reduce((p, k) => {
      if (p) {
        return true;
      }
      return this.state.loaders[k];
    }, false);
    return (<LoaderProvider value={{
      setLoading: this.setLoading,
    }}>
      {isLoading ? <Loader /> : undefined}
      {this.props.children}
    </LoaderProvider>);
  }
}

export function LoaderHOC<P extends object>(Target: React.ComponentType<P & LoaderContextValue>) {
  const hoc = (props: React.PropsWithChildren<P>) => (<LoaderConsumer>
    {({setLoading}) => (<Target setLoading={setLoading} {...props} />)}
  </LoaderConsumer>);
  hoc.displayName = `LoaderHOC<${Target.toString()}>`;
  return hoc;
}
